export const context =
  (<any>window).school_context == 'dar_albayan' ? 'bayen_school' : 'manarah_school'
